import { render, staticRenderFns } from "./StudentChoose.vue?vue&type=template&id=2a57dc61&scoped=true&"
import script from "./StudentChoose.vue?vue&type=script&lang=js&"
export * from "./StudentChoose.vue?vue&type=script&lang=js&"
import style0 from "./StudentChoose.vue?vue&type=style&index=0&id=2a57dc61&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a57dc61",
  null
  
)

export default component.exports